export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-trophy-3de40dbd02ae4d898868a2acada3f367.svg";